import React from 'react';

import PropTypes from 'prop-types';

import LeftIcon from '@/assets/icons/left-arrow.svg';
import RightIcon from '@/assets/icons/right-arrow.svg';

import Button from '../button/Button.jsx';
import Pagination from '../pagination/Pagination.jsx';

import StandalonePopUp from './StandalonePopUp';

import './PopUpWizard.less';

class PopUpWizard extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      idActiveContent: 0,
      data: props.data,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.updatePopUpWizard(nextProps);
  }

  onClick = (e) => {
    const {idActiveContent, data} = this.state;
    const {id} = e.currentTarget;
    const dataLength = data.length;
    let ActiveContent = idActiveContent;
    switch (id) {
      case 'LeftButton':
        if (ActiveContent <= 0) ActiveContent = dataLength - 1;
        else ActiveContent--;
        break;
      case 'RightButton':
        if (ActiveContent >= dataLength - 1) ActiveContent = 0;
        else ActiveContent++;
        break;
      default:
        break;
    }
    this.setState({
      idActiveContent: ActiveContent,
    });
  };

  onClose = () => {
    const {onClose} = this.props;
    this.setState({
      idActiveContent: 0,
    });
    onClose();
  };

  updatePopUpWizard(nextProps) {
    const {data} = this.props;
    if (data !== nextProps.data) {
      this.setState({
        idActiveContent: 0,
        data: nextProps.data,
      });
    }
  }

  render() {
    const {idActiveContent, data, fontSize} = this.state;
    const {popUpWizardVisible} = this.props;
    const style = {
      constraint: {
        fontSize,
      },
    };

    return (
      <StandalonePopUp
        onClose={this.onClose}
        isPopUpVisible={popUpWizardVisible}
        contents={{
          popUpTitle: data[idActiveContent].Title,
          popUpBody: (
            <div className="row center">
              <div className="col-md-1">
                {data.length > 1 ? (
                  <Button
                    id="LeftButton"
                    className="popUpWizard-Button"
                    onClick={this.onClick}
                    icon={LeftIcon}
                  />
                ) : null}
              </div>
              <div
                className="col-md-10 contentBody no-padding"
                style={style.constraint}
              >
                {data[idActiveContent].Content}
              </div>
              <div className="col-md-1">
                {data.length > 1 ? (
                  <Button
                    id="RightButton"
                    className="popUpWizard-Button"
                    onClick={this.onClick}
                    icon={RightIcon}
                  />
                ) : null}
              </div>
            </div>
          ),
          popUpFooter: (
            <div className="row center">
              {data.length > 1 ? (
                <Pagination
                  total={data.length}
                  current={idActiveContent + 1}
                />
              ) : null}
            </div>
          ),
        }}
        dialogClassName="popUpWizard-dialogClassName"
        headerClassName="popUpWizard-modal-header"
        footerClassName="popUpWizard-modal-footer"
      />
    );
  }
}

PopUpWizard.propTypes = {
  onClose: PropTypes.func,
  data: PropTypes.array,
  popUpWizardVisible: PropTypes.bool,
};

PopUpWizard.defaultProps = {
  onClose: () => {},
  data: [],
  popUpWizardVisible: false,
};

export default PopUpWizard;
